<template>
  <v-card class="main_card" rounded="lg" height="100%">
    <v-card-title
      class="justify-center pt-2 v-card__title pa-2"
      style="color: var(--v-btntext-base);"
    >{{ title }}</v-card-title>
    <v-card-text class="d-flex justify-space-between pt-4 pb-3 px-0">
      <span class="state_name ma-1">{{ stateName }}</span>
      <span
        class="font-weight-bold state_value ma-1"
        style="color: var(--v-txtblue-base)"
      >{{ stateValue }}</span>
    </v-card-text>
    <v-card-text class="py-0" style="background-color: var(--v-cardtextbg2-base);">
      <table>
        <tr>
          <th style="color: #7CE299">가동</th>
          <th style="color: #E46060">고장</th>
          <th style="color: #b99c00">통신</th>
        </tr>
        <tr>
          <td style="color: #7CE299">{{ runVal }}</td>
          <td style="color: #E46060">{{ errVal }}</td>
          <td style="color: #b99c00">{{ strVal }}</td>
        </tr>
      </table>
    </v-card-text>
  </v-card>
</template>

<script>
// 스크립트를 정의하는 부분
// 개발자 작업 영역
export default {
  props: {
    title: {
      type: String
    },
    stateName: {
      type: String
    },
    stateValue: {
      type: Number,
      default: 0
    },
    runVal: {
      type: Number,
      default: 0
    },
    errVal: {
      type: Number,
      default: 0
    },
    strVal: {
      type: Number,
      default: 0
    },
    visible: {
      type: Boolean
    }
  },
  name: 'StateTable',
  components: {},
  data() {
    return {
      count: 0
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
  },
  mounted() {
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
    thColor() {
      if (this.stockState === 'D') {
        return 'background-color:rgb(193,85,73);'
      } else if (this.stockState === 'J') {
        return 'background-color:rgb(81,145,215);'
      } else if (this.stockState === 'G') {
        return 'background-color:rgb(42,149,165);'
      } else if (this.stockState === 'M') {
        return 'background-color:rgb(107,117,206);'
      }
      return ''
    },
    tbColor() {
      if (this.stockState === 'D') {
        return 'border:1px solid rgb(193,85,73);'
      } else if (this.stockState === 'J') {
        return 'border:1px solid rgb(81,145,215);'
      } else if (this.stockState === 'G') {
        return 'border:1px solid rgb(42,149,165);'
      } else if (this.stockState === 'M') {
        return 'border:1px solid rgb(107,117,206);'
      }
      return ''
    }
  },
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
  }
}
</script>

<style  lang="scss" scoped>
.main_card {
  table {
    font-size: 13px;
    width: 100%;
    color: black;
    border-collapse: collapse;
    tr {
      td {
        font-weight: bold;
        text-align: center;
        padding-top: 2px;
        padding-bottom: 2px;
        font-size: 14px;
      }
      th {
        font-weight: bold;
        text-align: center;
        padding-top: 2px;
        padding-bottom: 2px;
        font-size: 14px;
      }
    }
  }
}
.state_value {
  font-size: 30px;
  font-weight: 500 !important;
  // color: #1255a5;
  letter-spacing: -1px;
}
.state_name {
  overflow: hidden;
  text-overflow: ellipsis;
  // color: rgb(88, 126, 169);
  color: var(--v-btntext-base);
  white-space: nowrap;
  font-size: 14px;
}
.v-card__title {
  font-size: 1.16rem !important;
}
</style>
